const TrainingCourseLoading = () => {
    return (
        <>
            {/* making array for courses */}
            {[...Array(9)].map((_, i) => (
                // this is the loading box 
                <div className='relative pt-7 pb-3 px-3 grid grid-cols-[33%_67%] rounded-lg w-full h-44 max-lg:h-full max-2xl:grid-cols-1 l-load' key={i}>
                    <div className='relative w-32 max-md:w-44 max-2xl:h-16'>
                        <div className='absolute w-32 h-28 -top-16 inset-y-0 -start-8 max-md:relative max-lg:h-28 max-md:w-44 l-load-dt rounded-lg'>
                        </div>
                    </div>
                    <div className="flex flex-col justify-between">
                        <div className="w-full space-y-2">
                            <div className="w-48 max-md:w-auto h-2 rounded-md l-load-dt"></div>
                            <div className="w-28 max-md:w-auto h-2 rounded-md l-load-dt"></div>
                            <div className="w-36 max-md:w-auto h-2 rounded-md l-load-dt"></div>
                        </div>
                        <div className="flex w-full gap-2 items-center justify-end mt-1">
                            <div className="w-20 h-4 l-load-dt rounded-md"></div>
                            <div className="w-24 h-8 l-load-dt rounded-md"></div>
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}
export default TrainingCourseLoading;